export const isUndefined = <T>(value: T): boolean => value === undefined && value === void 0;
export const isNil = <T>(value: T): boolean => isUndefined(value) || value === null;
